import styled from 'styled-components';

export const Table = styled.table`
  background-color: var(--ui-surface);
  border: 1px solid var(--ui-border);
  border-radius: var(--border-radius-large);
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
`;

export const TableHeader = styled.thead`
  background-color: var(--brand-primary);
  color: var(--text-inverse);
`;

export const TableHeaderCell = styled.th`
  padding: var(--space-2);
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-label);
  text-align: left;
  border-bottom: 1px solid var(--ui-border);

  &:hover {
    background-color: var(--brand-primary-hover);
  }
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
  height: 28px;
  border-bottom: 1px solid var(--border-gridline);

  &:nth-child(even) {
    background-color: var(--ui-surface-alt);
  }

  &:hover {
    background-color: var(--ui-surface-hover-alt);
    color: var(--brand-primary);
  }

  &.selected {
    background-color: var(--brand-primary);
    color: var(--text-inverse);
  }
`;

export const TableCell = styled.td`
  padding: var(--space-2);
  font-size: var(--font-size-body);
  border-bottom: 1px solid var(--border-gridline);
`;

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: var(--border-radius-large);
  border: 1px solid var(--ui-border);
`;

export const TableFooter = styled.div`
  background-color: var(--ui-surface-alt);
  padding: var(--space-3);
  border-top: 1px solid var(--ui-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: var(--font-size-label);
  color: var(--text-secondary);
`;

export const TablePagination = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-2);
`;

export const TableInfo = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-2);
`;

